<template>
    <app-layout>
         <Head title="Inbox"/>
        <div class="max-w-7xl mx-auto flex pb-12 mb-12">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg md:flex">
                    <div class="md:w-1/3 border-r border-solid border-gray-300">
                        <section>
                            <h3 class="p-3 font-bold border-b border-solid border-gray-300 bg-gray-50">
                                Browse Conversations
                            </h3>
                            <div class="pt-1">
                                <div class="px-3 pt-4 pb-4">
                                    <button-select
                                        v-model="messageable_type"
                                        :options="{ contact: 'Contacts', group: 'Lists' }"
                                        default="contact"
                                    />
                                </div>
                                <div class="px-3 pb-5" v-if="messageable_type === 'contact'">
                                    <contact-select v-model="selectFormContact" v-bind:allow-multiple="false" />
                                </div>
                                <div class="px-3 pb-5" v-else-if="messageable_type === 'group'">
                                    <group-select v-model="selectFormGroup" />
                                </div>
                            </div>
                        </section>
                        <div id="contactListContainer">
                            <section v-if="messageable_type === 'contact' && unread_contacts.length">
                                <h3 class="p-3 font-bold border-b border-solid border-gray-300 bg-gray-50">
                                    Unread Messages
                                </h3>
                                <MessagesContactLabel
                                    v-for="contact in unread_contacts"
                                    :key="contact.id"
                                    :contact="contact"
                                    type="unread_messages"
                                    @click="fetchContact(contact)"
                                />
                            </section>
                            <section>
                                <h3 class="p-3 font-bold border-b border-solid border-gray-300 bg-gray-50">
                                    Select from Recent
                                </h3>
                                <div v-if="messageable_type === 'contact'">
                                    <MessagesContactLabel
                                        v-for="contact in recent_contacts"
                                        :key="contact.id"
                                        :contact="contact"
                                        @click="fetchContact(contact)"
                                    />
                                </div>
                                <div v-else-if="messageable_type === 'group'">
                                    <MessagesContactLabel
                                        v-for="group in recent_groups"
                                        :key="group.id"
                                        :contact="group"
                                        type="group"
                                        @click="fetchGroup(group)"
                                    />
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="md:w-2/3">
                        <InboxLoadingPlaceholder v-if="loading" />
                        <div v-else-if="selected">
                            <div class="border-b border-solid border-gray-300 p-3 bg-gray-50">
                                <h2 class="">
                                    <span class="font-bold mr-2">{{ selectedCommon.name }}</span>
                                    <span v-if="selected_type === 'contact'" class="ml-2 pl-4 border-l border-solid border-gray-600">{{ selected.phone_number }}</span>
                                </h2>
                            </div>
                            <inbox-messages :message-container="selected" :type="selected_type" />
                            
                            <div class="error" role="alert" v-if="isBadContact">
                                Messages can not be sent to {{ selectedCommon.name }} because {{badContactReason}}.
                            </div>
                            <form v-else @submit.prevent="handleSendMessage()" class="flex flex-col border border-solid border-gray-300">
                                <textarea
                                    class="w-full p-3 focus:outline-none border-l-2 border-gray-300 focus:border-blue-300"
                                    v-model="message"
                                    rows="3"
                                    required
                                    :placeholder="`Type a message to ${selectedCommon.name}...`"
                                ></textarea>
                                <div v-if="sendTypeValue !== 'now'" class="p-3 py-4 bg-blue-100">
                                    <message-form-later v-model="send_time" v-if="sendTypeValue === 'later'" />
                                    <message-form-recurring v-model="recurringFormData" v-if="sendTypeValue === 'recurring'" />
                                </div>
                                <div class="flex justify-end items-center">
                                    <div class="text-right">
                                        <multiselect
                                            :options="sendTypeOptions"
                                            label="label"
                                            v-model="send_type"
                                            :close-on-select="true"
                                            select-label=""
                                            deselect-label=""
                                            placeholder=""
                                            :internal-search="false"
                                            :searchable="false"
                                        />

                                    </div>
                                    <jet-button class="self-end m-3" :disabled="sending">{{ sendTypeValue === 'now' ? 'Send' : 'Schedule' }}</jet-button>
                                </div>
                            </form>
                        </div>
                        <InboxBlankPlaceholder v-else />
                    </div>
                </div>
            </div>
        </div>

        <jet-dialog-modal :show="creditOverageModal" @close="closeOverageModal()">
            <template #title>
                Credit Limit Exceeded
            </template>

            <template #content>
                <p>
                    <template v-if="$page.props.grace_period">
                        You can not exceed your credit limit with renewal turned off.
                    </template>
                    <template v-else>
                        You are only allowed to exceed your monthly/annual credit limit by 2x and sending this message would exceed that limit. Please upgrade your account to a plan with a higher credit limit, or adjust your message to use fewer credits to continue.
                    </template>
                    <br>
                </p>

                <ul class="list-disc mt-2 pl-4 mb-2">

                    <li class="font-bold">
                        Remaining Credits: {{ creditLimitData.available_segments }}
                    </li>
                    <li class="font-bold">
                        Credits required to send this message: {{ creditCount }}
                    </li>
                </ul>

                <p>If you have any questions about how message credits are calculated, please review our article: <a class ='text-blue-400 underline' target="_blank" href="https://help.textspot.io/en/articles/9117502-what-are-credits-and-how-do-they-work">How do credits work?</a></p>

            </template>

            <template #footer>
                <a href="#" class="mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" v-on:click="closeOverageModal()" >Cancel</a>

                <Link :href="route('subscriptions.index')" class="w-full text-center">
                    <jet-secondary-button @click="closeOverageModal()">
                        View Plans
                    </jet-secondary-button>
                </Link>


            </template>
        </jet-dialog-modal>
        
       <trial-only-message-yourself-modal v-if="showTrialOnlyMessageYourselfModal" @close="closeTrialOnlyMessageYourselfModal" />
       <contact-in-use-on-trial-modal v-if="showContactInUseOnTrialModal" @close="showContactInUseOnTrialModal = false" />
       <limited-contacts-on-trial-modal v-if="showLimitedContactsOnTrialModal" @close="showLimitedContactsOnTrialModal = false" />
       <your-org-needs-to-get-verified-modal v-if="showYourOrgNeedsToGetVerifiedModal" @close="closeYourOrgNeedsToGetVerifiedModal" />

       <message-held-for-review-modal
            v-if="messageHeldForReviewIsOpen"
            @close="closeMessageHeldForReviewModal()"
        />

        <your-account-is-paused-modal
            v-if="showYourAccountIsPausedModal"
            @close="showYourAccountIsPausedModal = false"
        />

        <phone-number-not-active-modal v-if="showPhoneNumberNotActiveModal" @close="showPhoneNumberNotActiveModal = false" />
        <phone-number-pending-tcr-update v-if="showPhoneNumberPendingTcrUpdateModal" @close="showPhoneNumberPendingTcrUpdateModal = false" />
        <credit-overage-warning-modal :creditLimitAvailabilityResponse="creditLimitData" />
        <daily-limit-warning-modal v-if="showDailyLimitWarningModal" :dailyLimitAvailabilityResponse="dailyLimitData" @close="showDailyLimitWarningModal = false" />
        <message-held-on-trial-modal v-if="showMessageHeldOnTrialModal" @close="showMessageHeldOnTrialModal = false" />
    </app-layout>
</template>

<script>
import AppLayout from '../../Layouts/AppLayout';
import JetButton from '../../Jetstream/Button';
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';
import ContactSelect from '../../components/ContactSelect';
import GroupSelect from '../../components/GroupSelect';
import InboxMessages from '../../components/InboxMessages';
import ButtonSelect from '../../components/ButtonSelect';

import {mapWritableState, mapActions, mapState} from 'pinia';
import inboxStore from '../../Stores/inbox.js';
import { useModalStore } from '@/Stores/modal';
import MessagesContactLabel from '../../components/Inbox/MessagesContactLabel';
import InboxBlankPlaceholder from '../../components/Inbox/InboxBlankPlaceholder';
import InboxLoadingPlaceholder from '../../components/Inbox/InboxLoadingPlaceholder';
import MessageHeldForReviewModal from '../../components/Modals/MessageHeldForReview';
import TrialOnlyMessageYourselfModal from '@/components/Modals/TrialOnlyMessageYourselfModal.vue';
import YourOrgNeedsToGetVerifiedModal from '@/components/Modals/YourOrgNeedsToGetVerifiedModal.vue';
import YourAccountIsPausedModal from '@/components/Modals/YourAccountIsPausedModal.vue';
import CreditOverageWarningModal from '@/components/Modals/CreditOverageWarningModal.vue';
import DailyLimitWarningModal from '@/components/Modals/DailyLimitWarningModal.vue';
import MessageFormLater from '@/components/MessageForm/MessageFormLater';
import MessageFormRecurring from '@/components/MessageForm/MessageFormRecurring.vue';
import MessageHeldOnTrialModal from '@/components/Modals/MessageHeldOnTrial.vue';
import ContactInUseOnTrialModal from '@/components/Modals/ContactInUseOnTrialModal.vue';
import LimitedContactsOnTrialModal from '@/components/Modals/LimitedContactsOnTrialModal.vue';

import PhoneNumberNotActiveModal from '@/components/Modals/PhoneNumberNotActiveModal.vue';
import PhoneNumberPendingTcrUpdate from '@/components/Modals/PhoneNumberPendingTcrUpdate.vue';

import { useGlobalStore } from '@/Stores/global';
import { SegmentedMessage } from 'sms-segments-calculator';

export default {
    components: {
        AppLayout,
        JetButton,
        JetDialogModal,
        JetSecondaryButton,
        ContactSelect,
        GroupSelect,
        InboxMessages,
        ButtonSelect,
        MessagesContactLabel,
        InboxBlankPlaceholder,
        InboxLoadingPlaceholder,
        MessageHeldForReviewModal,
        TrialOnlyMessageYourselfModal,
        YourOrgNeedsToGetVerifiedModal,
        YourAccountIsPausedModal,
        PhoneNumberNotActiveModal,
        PhoneNumberPendingTcrUpdate,
        CreditOverageWarningModal,
        DailyLimitWarningModal,
        MessageFormLater,
        MessageFormRecurring,
        MessageHeldOnTrialModal,
        ContactInUseOnTrialModal,
        LimitedContactsOnTrialModal,
    },
    props: {
        recent_contacts: Array,
        recent_groups: Array,
        unread_contacts: Array,
    },
    data() {
        return {
            message: "",
            messageable_type: 'contact',
            selected: null,
            selected_type: null,
            selectFormContact: null,
            selectFormGroup: null,
            send_type: null,
            send_time: null,
            show_later_modal: true,
            messageHeldForReviewIsOpen: false,
            confirm_send: '',
            loading: false,
            sending: false,
            creditOverageModal: false,
            creditLimitData: {
                available_segments: 0,
            },
            dailyLimitData: null,
            recurringFormData: {
                interval: 1,
                repeats_type: 'DAILY',
                repeats_on: [],
                recurring_ends: 'never',
                count: 1,
                end_date: null,
                start_date: null
            },
            showTrialOnlyMessageYourselfModal: false,
            showYourOrgNeedsToGetVerifiedModal: false,
            showYourAccountIsPausedModal: false,
            showPhoneNumberNotActiveModal: false,
            showPhoneNumberPendingTcrUpdateModal: false,
            showMessageHeldOnTrialModal: false,
            showContactInUseOnTrialModal: false,
            showLimitedContactsOnTrialModal: false,
            showDailyLimitWarningModal: false,
        }
    },
    computed: {
        ...mapWritableState(inboxStore, ['activeContact', 'readContacts']),
        ...mapState(useGlobalStore, [
            'phoneNumberPendingTcrUpdate',
            'isPhoneNumberActive',
        ]),
        ...mapState(useModalStore,{
            creditOverageWarningModalResolve: 'resolve',
        }),
        sendTypeOptions() {
            return [
                { value: 'now', label: 'Send Now' },
                { value: 'later', label: 'Send Later' },
                { value: 'recurring', label: 'Recurring' }
            ];
        },
        sendTypeValue() {
            if (this.send_type) {
                return this.send_type.value;
            }
            return 'now';
        },
        userHasSubscription() {
          return this.$page.props.auth.user.organization.has_active_subscription;
        },
        sendParamName() {
            if ( this.selected_type === 'contact' ) {
                return 'contacts';
            }

            if ( this.selected_type === 'group' ) {
                return 'group_id';
            }
        },
        selectedValue() {
            if ( this.selected_type === 'contact' ) {
                return [this.selected.id];
            }

            if ( this.selected_type === 'group' ) {
                return this.selected.id;
            }
        },
        sendFormData() {
            let formData = {
                unparsed_message: this.message,
                [`${this.sendParamName}`]: this.selectedValue,
                send_time: this.sendTypeValue === 'later' ? this.send_time : null,
                is_recurring: this.sendTypeValue === 'recurring',
                recurring_params: this.recurringFormData,
                confirm_send: this.confirm_send,
                is_axios: true
            };

            return formData;
        },
        selectedCommon() {
            // Creates an object with common conventions for property names
            // for Contacts and Lists
            let selectedCommon = Object.assign({}, this.selected);

            if (this.selected_type === 'contact') {
                selectedCommon.name = selectedCommon.full_name;
            } else if (this.selected_type === 'group') {
                selectedCommon.name = selectedCommon.title;
            }

            return selectedCommon;
        },
        creditCount() {
            return this.messageSegments.segments.length * this.contactCount;
        },
        messageSegments() {
            return new SegmentedMessage(this.message);
        },
        contactCount() {

            if (this.messageable_type == 'contact') {
                return 1;
            } else if (this.messageable_type == 'group' && this.selected) {
                return this.selected.contact_length;
            }
            return 0;
        },
        isBadContact() {
            if (this.selected_type != 'contact') return false;

            return (
                this.selected.bad_contact ||
                this.selected.do_not_contact
            )
        },
        badContactReason() {
            if(! this.selected) return '';

            if(this.selected.do_not_contact) {
                return "they have opted out";
            }
            if (this.selected.bad_contact) {
                return "there was a failure to send previously";
            }
        }
    },
    beforeUnmount() {
        this.activeContact = null;
    },
    methods: {
        ...mapActions(useModalStore, {
            showCreditOverageWarningModal: 'showModal',
        }),
        closeTrialOnlyMessageYourselfModal() {
            this.showTrialOnlyMessageYourselfModal = false;
        },
        closeYourOrgNeedsToGetVerifiedModal() {
            this.showYourOrgNeedsToGetVerifiedModal = false;
        },
        recipientSelected(message) {
            // short circuit early if this is missing
            if ( !message.group && !message.contact ) {
                return false;
            }

            let recipientId = message.group ? message.group.tra_id : message.contact.tra_id;

            return recipientId === this.selected.tra_id;
        },
        handleUnreadContact(contact) {
            this.read_contacts.push(contact);
            this.fetchContact(contact.tra_id);
        },
        async handleSendMessage() {
            this.sending = true;

            if (this.$page.props.auth.user.organization.suspended) {
                this.$toasted.show("Your organization is currently suspended and cannot send messages.", {
                    position: "bottom-right",
                    type: "error",
                    duration: 3000
                });
                this.sending = false;
                return;
            }

            if (this.$page.props.paused) {
                this.showYourAccountIsPausedModal = true;
                this.sending = false;
                return;
            }

            if (this.$page.props.subscribed && !this.$page.props.a2p_status_good_to_send) {
                this.showYourOrgNeedsToGetVerifiedModal = true;
                this.sending = false;
                return;
            }

            if (this.$page.props.active_trial) {
                let pendingStatus = await axios.get(route('organizations.activeTrialPendingReview'));
                if (pendingStatus.data.status) {
                    this.showMessageHeldOnTrialModal = true;
                    this.sending = false;
                    return;
                }
            }
            

            // Check daily credit limit for A2P send-limited organizations FIRST
            if (this.$page.props.a2p_send_limited) {
                let dailyLimitResponse = await axios.get('/api/messages/check-daily-limit', {
                    params: {
                        credits_considering: this.creditCount
                    }
                });
                this.dailyLimitData = dailyLimitResponse.data;
                
                if (!dailyLimitResponse.data.approved) {
                    this.showDailyLimitWarningModal = true;
                    this.sending = false;
                    return;
                }
            }

            let creditResponse = await axios.get('/api/messages/check-credits', {
                params: {
                    estimated_credits: this.creditCount
                }
            });
            this.creditLimitData = creditResponse.data;
            let approved = creditResponse.data.approved;

            //we need to check credit limit availability
            if (!approved) {
                this.creditOverageModal = true;
                this.sending = false;
                return;
            }

            if (creditResponse.data.overage_warning) {
                let response = await this.showCreditOverageWarningModal();
                if (!response) {
                    //they closed the modal
                    this.sending = false;
                    return;
                }
            }

            if (this.$page.props.active_trial) {
                // Check trial contact limits
                let trialContactCheck;
                if (this.messageable_type == 'group') {
                    trialContactCheck = await axios.get(route('messages.checkTrialContactLimit'), {
                        params: { group_tra_id: this.selected.tra_id }
                    });
                } else if (this.messageable_type == 'contact') {
                    trialContactCheck = await axios.get(route('messages.checkTrialContactLimit'), {
                        params: { contact_tra_ids: [this.selected.tra_id] }
                    });
                }

                if (trialContactCheck && !trialContactCheck.data.approved) {
                    if (trialContactCheck.data.reason_code === 'CONTACT_IN_USE_BY_OTHER_TRIAL') {
                        this.showContactInUseOnTrialModal = true;
                    } else if (trialContactCheck.data.reason_code === 'TRIAL_CONTACT_LIMIT_EXCEEDED') {
                        this.showLimitedContactsOnTrialModal = true;
                    }
                    this.sending = false;
                    return;
                }
            }

            if (this.phoneNumberPendingTcrUpdate) {
                this.showPhoneNumberPendingTcrUpdateModal = true;
                this.sending = false;
                return;
            }

            if (!this.isPhoneNumberActive) {
                this.showPhoneNumberNotActiveModal = true;
                this.sending = false;
                return;
            }

            axios
                .post(route('md.create.submit'), this.sendFormData)
                .then(response => {
                    this.$toasted.show(`Your message has been successfully ${this.sendTypeValue === 'now' ? 'queued for sending' : 'scheduled'}!`, {
                        position: 'bottom-right',
                        type: 'success',
                        duration: 3000
                    });
                    this.resetMessageForm();
                    if (this.messageable_type == 'group') {
                        this.fetchGroup(this.activeContact);
                    } else {
                        this.fetchContact(this.activeContact);
                    }
                    this.sending = false;
                })
                .catch(error => {
                    let errorMessage = "Uh oh! Something went wrong.";

                    if ( typeof error.response.data.message !== 'undefined' && error.response.data.message == 'held_for_review' ) {
                        this.messageHeldForReviewIsOpen = true;
                        this.sending = false;
                        return;
                    }

                    if ( error.response.data.message ) {
                      errorMessage = error.response.data.display_message;
                    }

                    this.$toasted.show(errorMessage, {
                        position: 'bottom-right',
                        type: 'error',
                        duration: 3000
                    });
                    this.sending = false;
                });
        },
        fetchContact(contact) {
            if (!contact || !contact.tra_id) return;

            this.activeContact = contact;
            this.loading = true;
            axios
                .get(route('inbox.view.contact.messages', {traId: contact.tra_id}))
                .then(response => {
                    this.selectContact(response.data);
                    //if they are an unread contact AND have not been marked as read yet...
                    if(contact.has_notification && ! _.some(this.readContacts, {tra_id: contact.tra_id})) {
                        this.readContacts.push(contact);
                    }
                    this.resetSelectForm();
                    this.loading = false;
                });
        },
        fetchGroup (group) {
            this.loading = true;
            this.activeContact = group;
            axios
                .get(route('inbox.view.group.messages', {
                    traId: group.tra_id
                }))
                .then(response => {
                    this.selectGroup(response.data);
                    this.resetSelectForm();
                    this.loading = false;
                })
        },
        selectContact(contact) {
            this.selected = contact;
            this.selected_type = 'contact';
            this.activeContact = contact;
        },
        selectGroup(group) {
            this.selected = group;
            this.selected_type = 'group';
        },
        resetMessageForm() {
            this.message = '';
            this.send_type = this.sendTypeOptions[0];
            this.send_time = null;
            this.recurringFormData = {
                interval: 1,
                repeats_type: 'DAILY',
                repeats_on: [],
                recurring_ends: 'never',
                count: 1,
                end_date: null,
                start_date: null,
            };
        },
        resetSelectForm() {
            this.selectFormContact = null;
            this.selectFormGroup = null;
        },
        closeMessageHeldForReviewModal() {
            this.messageHeldForReviewIsOpen = false;
            this.resetMessageForm();
        },
        closeOverageModal() {
            this.creditOverageModal = false;
        },
        confirmSend() {
            this.confirm_send = 'y';
            this.closeSpamModal();
            this.handleSendMessage();
        }
    },
    watch: {
        selectFormContact() {
            if (!this.selectFormContact) return;
            this.fetchContact(this.selectFormContact)
        },
        selectFormGroup() {
            if (!this.selectFormGroup) return;
            this.fetchGroup(this.selectFormGroup)
        },
        messageable_type() {
            this.selected = null;
        }
    },
    mounted () {
        this.send_type = this.sendTypeOptions[0];
    }
}
</script>

<style scoped>
.error {
    @apply bg-red-100 border-t border-b border-red-500 text-red-700 px-4 py-3 text-center;
}

@media (min-width: theme('screens.sm')) {
    #contactListContainer {
        height: 430px;
        max-height: 430px;
        overflow-y: auto;
    }
}

</style>
